import { NestedKeys } from '@/types/properties';
import {
	treatments as Treatments,
	outcomes as Outcomes,
} from '@scitrials-sst/core/Next/constants';

export type DataType = {
	title: string;
	section: NestedKeys;
	key: { label: string; value: string }[];
};

export const treatments: DataType = {
	title: 'treatments',
	section: 'treatments',
	key: Treatments.map((treatment) => ({
		label: treatment.label,
		value: treatment.value,
	})),
};

export const outcomes: DataType = {
	title: 'outcomes',
	section: 'outcomes',
	key: Outcomes.map((outcome) => ({
		label: outcome.label,
		value: outcome.value,
	})),
};

export const marked: DataType = {
	title: 'marked trials',
	section: 'markedTrials',
	key: [
		{ label: 'Followed By You', value: 'followedByYou' },
		{ label: 'Hidden By You', value: 'hiddenByYou' },
	],
};

export const status: DataType = {
	title: 'trial status',
	section: 'trialStatus',
	key: [
		{ label: 'Recruiting', value: 'RECRUITING' },
		{ label: 'Enrolling by invitation', value: 'ENROLLING_BY_INVITATION' },
		{ label: 'Active, not recruiting', value: 'ACTIVE_NOT_RECRUITING' },
		{ label: 'Not yet recruiting', value: 'NOT_YET_RECRUITING' },
		{ label: 'Unknown status', value: 'UNKNOWN' },
	],
};

export const other: DataType = {
	title: 'other',
	section: 'other',
	key: [
		{ label: 'With Overviews', value: 'reviewed' },
		{ label: 'No Overview', value: 'not_reviewed' },
	],
};
